import 'shims';

import Collapse from 'bootstrap.native/dist/components/collapse-native.esm.js';
import Modal from 'bootstrap.native/dist/components/modal-native.esm.js';

import initNavbar from 'Components/navbar';

function load() {
  // abort the load if an error has already been displayed
  if (window.preLoader.loadErrorOccurred) {
    return;
  }

  window.preLoader.removeErrorHandlers();

  initNavbar();

  document
    .querySelectorAll('[data-toggle=collapse]')
    .forEach(el => new Collapse(el));

  document
    .querySelectorAll('[data-toggle=modal]')
    .forEach(el => new Modal(el));
}

window.addEventListener('load', load);
